__turbopack_context__.v({
  "enterYourEmail": "text-field1-module-scss-module__ggOCQa__enterYourEmail",
  "error": "text-field1-module-scss-module__ggOCQa__error",
  "errorText": "text-field1-module-scss-module__ggOCQa__errorText",
  "label": "text-field1-module-scss-module__ggOCQa__label",
  "row": "text-field1-module-scss-module__ggOCQa__row",
  "textField": "text-field1-module-scss-module__ggOCQa__textField",
});
